import React, { useState } from 'react';
import MyOrders from './MyOrders'; // Component for orders
import Addresses from '../components/Addresses'; // Component for addresses
import DeleteAccount from './DeleteAccount'; // Component for deleting account

const MyAccount = () => {
  const [activeTab, setActiveTab] = useState('orders'); // State to track active tab

  const renderTabContent = () => {
    switch (activeTab) {
      case 'orders':
        return <MyOrders />;
      case 'addresses':
        return <Addresses />;
      case 'deleteAccount':
        return <DeleteAccount />;
      default:
        return <MyOrders />;
    }
  };

  return (
    <div className="container p-4">
      <h1>My Account</h1>
      <div style={{ display: 'flex', marginBottom: '20px' }}>
        <button
          onClick={() => setActiveTab('orders')}
          style={{
            padding: '10px 20px',
            marginRight: '10px',
            backgroundColor: activeTab === 'orders' ? '#007bff' : '#f0f0f0',
            color: activeTab === 'orders' ? 'white' : 'black',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
        >
          Orders
        </button>
        <button
          onClick={() => setActiveTab('addresses')}
          style={{
            padding: '10px 20px',
            marginRight: '10px',
            backgroundColor: activeTab === 'addresses' ? '#007bff' : '#f0f0f0',
            color: activeTab === 'addresses' ? 'white' : 'black',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
        >
          Addresses
        </button>
        <button
          onClick={() => setActiveTab('deleteAccount')}
          style={{
            padding: '10px 20px',
            backgroundColor: activeTab === 'deleteAccount' ? '#007bff' : '#f0f0f0',
            color: activeTab === 'deleteAccount' ? 'white' : 'black',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
        >
          Delete My Account
        </button>
      </div>
      <div>{renderTabContent()}</div>
    </div>
  );
};

export default MyAccount;